import Home from "pages";
import {useEffect} from "react";
import { getPageData } from "../../utils/getSeoMenu";
import {
  viewFrontPage,
} from "@/components/common/Nosto";
import { useRouter } from "next/compat/router";
import { useSelector } from "react-redux";
import Head from "next/head";

export const getStaticProps = async () => {
  return {
    props: { homepage: await getPageData('/') || null},
    revalidate: 60,
  };
};


const AccountPage = ({ homepage }) => {
  const router = useRouter();
  const loggedIn = useSelector((state) => state.loginUser);

  //to handle api calls when logged in using /login
  useEffect(() => {
    if (router.asPath === "/account") {
      viewFrontPage();
    }
  }, [loggedIn])

  return (
    <>
      <Head>
        <meta property="og:url" content={`${process.env.NETLIFY_URL}/account`}></meta>
        <meta
          property="og:image"
          content={`${process.env.NETLIFY_URL}/${process.env.OG_IMAGE_PATH}`}
        ></meta>
        <meta
          property="og:image:secure_url"
          content={`${process.env.NETLIFY_URL}/${process.env.OG_IMAGE_PATH}`}
        ></meta>
      </Head>
      <Home accountOpen={true} tabToOpen={"home"} content={homepage} />
    </>
  );
};

export default AccountPage;
